export const mandatoryDefaultFieldsCodes = ['firstName', 'lastName', 'email']
